/**
 * KDS Text Field — Figma node 49:146.
 *
 * | KDS    | `size` | Input height |
 * | ------ | ------ | ------------ |
 * | Small  | `sm`   | 32 px        |
 * | Medium | `md`   | 40 px        |
 * | Large  | `lg`   | 48 px        |
 */
export const textFieldHeights = {
  sm: '32px',
  md: '40px',
  lg: '48px',
} as const;

export type TextFieldSize = keyof typeof textFieldHeights;

export const textFieldSizes = Object.keys(textFieldHeights) as TextFieldSize[];

export const textFieldDefaultSize: TextFieldSize = 'sm';

/** Horizontal padding inside the input (Figma `sm` = 8px). */
export const textFieldInputPaddingX = '2';

/** Gap between label and input (Figma `2xs` = 4px). */
export const textFieldLabelGap = '1';

/** Leading / trailing icon box width (Figma 24px). */
export const textFieldIconBoxWidthPx = 24;

/** Gap between icon box and input text (Figma `2xs` = 4px). */
export const textFieldIconContentGapPx = 4;

/** Icon glyph size inside the box (Figma 20px). */
export const textFieldIconSizePx = 20;

/** Figma inline padding on the input shell (8px). */
export const textFieldInputInlinePaddingPx = 8;

/**
 * Input `padding-inline` when an icon is present on that side.
 * Figma: shell padding (8) + icon box (24) + content gap (4) = 36px.
 */
export const textFieldInputPaddingWithIconPx =
  textFieldInputInlinePaddingPx + textFieldIconBoxWidthPx + textFieldIconContentGapPx;

export const textFieldInputPaddingStartWithIcon = `${textFieldInputPaddingWithIconPx}px`;
export const textFieldInputPaddingEndWithIcon = `${textFieldInputPaddingWithIconPx}px`;
